var _style, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EC722E;}\n\t.st1{opacity:0.2;}\n\t.st2{fill:#EC722E;}\n\t.st3{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 32,
    r: 32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32,12c-0.8,0-1.5,0.7-1.5,1.5v8.2c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5v-8.2C33.5,12.7,32.8,12,32,12   z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.5,33.5c0-0.8-0.7-1.5-1.5-1.5h-8c-0.8,0-1.5,0.7-1.5,1.5S11.2,35,12,35h8C20.8,35,21.5,34.3,21.5,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32,44c-0.8,0-1.5,0.7-1.5,1.5v8c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5v-8C33.5,44.7,32.8,44,32,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.3,43.1c-0.4-0.7-1.3-1-2-0.5c-0.7,0.4-1,1.3-0.5,2l4,6.9c0.3,0.5,0.8,0.8,1.3,0.8c0.3,0,0.5-0.1,0.7-0.2   c0.7-0.4,1-1.3,0.5-2L39.3,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.3,15.4c-0.4-0.7-1.3-1-2-0.5c-0.7,0.4-1,1.3-0.5,2l4.1,7.1c0.3,0.5,0.8,0.8,1.3,0.8c0.3,0,0.5-0.1,0.7-0.2   c0.7-0.4,1-1.3,0.5-2L23.3,15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.9,28.3c0.3,0.5,0.8,0.8,1.3,0.8c0.3,0,0.5-0.1,0.7-0.2l7.1-4.1c0.7-0.4,1-1.3,0.5-2c-0.4-0.7-1.3-1-2-0.5   l-7.1,4.1C40.8,26.7,40.5,27.6,40.9,28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52,32h-8.2c-0.8,0-1.5,0.7-1.5,1.5S43,35,43.8,35H52c0.8,0,1.5-0.7,1.5-1.5S52.8,32,52,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.1,42.2l-6.9-4c-0.7-0.4-1.6-0.2-2,0.5c-0.4,0.7-0.2,1.6,0.5,2l6.9,4c0.2,0.1,0.5,0.2,0.7,0.2   c0.5,0,1-0.3,1.3-0.8C51,43.5,50.8,42.6,50.1,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.9,24.8l7.1,4.1c0.2,0.1,0.5,0.2,0.7,0.2c0.5,0,1-0.3,1.3-0.8c0.4-0.7,0.2-1.6-0.5-2l-7.1-4.1   c-0.7-0.4-1.6-0.2-2,0.5C13,23.5,13.2,24.4,13.9,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.9,38.8c-0.4-0.7-1.3-1-2-0.5l-6.9,4c-0.7,0.4-1,1.3-0.5,2c0.3,0.5,0.8,0.8,1.3,0.8c0.3,0,0.5-0.1,0.7-0.2   l6.9-4C23.1,40.4,23.3,39.5,22.9,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.8,42.6c-0.7-0.4-1.6-0.2-2,0.5l-4,6.9c-0.4,0.7-0.2,1.6,0.5,2c0.2,0.1,0.5,0.2,0.7,0.2   c0.5,0,1-0.3,1.3-0.8l4-6.9C27.7,43.9,27.5,43,26.8,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.2,24.6c0.2,0.1,0.5,0.2,0.7,0.2c0.5,0,1-0.3,1.3-0.8l4.1-7.1c0.4-0.7,0.2-1.6-0.5-2   c-0.7-0.4-1.6-0.2-2,0.5l-4.1,7.1C36.2,23.2,36.4,24.1,37.2,24.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32,10c-0.8,0-1.5,0.7-1.5,1.5v8.2c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5v-8.2C33.5,10.7,32.8,10,32,10   z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.5,31.5c0-0.8-0.7-1.5-1.5-1.5h-8c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5h8   C20.8,33,21.5,32.3,21.5,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32,42c-0.8,0-1.5,0.7-1.5,1.5v8c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5v-8C33.5,42.7,32.8,42,32,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.3,41.1c-0.4-0.7-1.3-1-2-0.5c-0.7,0.4-1,1.3-0.5,2l4,6.9c0.3,0.5,0.8,0.8,1.3,0.8c0.3,0,0.5-0.1,0.7-0.2   c0.7-0.4,1-1.3,0.5-2L39.3,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.3,13.4c-0.4-0.7-1.3-1-2-0.5c-0.7,0.4-1,1.3-0.5,2l4.1,7.1c0.3,0.5,0.8,0.8,1.3,0.8c0.3,0,0.5-0.1,0.7-0.2   c0.7-0.4,1-1.3,0.5-2L23.3,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.9,26.3c0.3,0.5,0.8,0.8,1.3,0.8c0.3,0,0.5-0.1,0.7-0.2l7.1-4.1c0.7-0.4,1-1.3,0.5-2c-0.4-0.7-1.3-1-2-0.5   l-7.1,4.1C40.8,24.7,40.5,25.6,40.9,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52,30h-8.2c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5H52c0.8,0,1.5-0.7,1.5-1.5C53.5,30.7,52.8,30,52,30z   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.1,40.2l-6.9-4c-0.7-0.4-1.6-0.2-2,0.5c-0.4,0.7-0.2,1.6,0.5,2l6.9,4c0.2,0.1,0.5,0.2,0.7,0.2   c0.5,0,1-0.3,1.3-0.8C51,41.5,50.8,40.6,50.1,40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.9,22.8l7.1,4.1c0.2,0.1,0.5,0.2,0.7,0.2c0.5,0,1-0.3,1.3-0.8c0.4-0.7,0.2-1.6-0.5-2l-7.1-4.1   c-0.7-0.4-1.6-0.2-2,0.5C13,21.5,13.2,22.4,13.9,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.9,36.8c-0.4-0.7-1.3-1-2-0.5l-6.9,4c-0.7,0.4-1,1.3-0.5,2c0.3,0.5,0.8,0.8,1.3,0.8c0.3,0,0.5-0.1,0.7-0.2   l6.9-4C23.1,38.4,23.3,37.5,22.9,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.8,40.6c-0.7-0.4-1.6-0.2-2,0.5l-4,6.9c-0.4,0.7-0.2,1.6,0.5,2c0.2,0.1,0.5,0.2,0.7,0.2   c0.5,0,1-0.3,1.3-0.8l4-6.9C27.7,41.9,27.5,41,26.8,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.2,22.6c0.2,0.1,0.5,0.2,0.7,0.2c0.5,0,1-0.3,1.3-0.8l4.1-7.1c0.4-0.7,0.2-1.6-0.5-2   c-0.7-0.4-1.6-0.2-2,0.5l-4.1,7.1C36.2,21.2,36.4,22.1,37.2,22.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.ed66ede3ab1485aead29716d2b0c02a1.svg";
export { ForwardRef as ReactComponent };